import { defineMessages } from 'react-intl';

// Shared by every step of the menu coachmark tour. Extraction keys messages by
// file path, so a copy per step file would become a separate translation unit.
export const sharedMessages = defineMessages({
  stepProgress: {
    defaultMessage: '{current}/{total}',
    id: 'GGDFrLVVkX',
    description: 'Coachmark step counter, for example 2/4',
  },
  next: {
    defaultMessage: 'Next',
    id: 'HyDFF4j1jT',
    description: 'Coachmark button that advances to the next step',
  },
});
